import createModel from './lib/create_model';

const TaskCompletionContent = createModel({
  modelName: 'TaskCompletionContent',

  properties: {
    note: String,
    taskItemId: String,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default TaskCompletionContent;
